import { createAction } from 'redux-actions';
export const setSelectedFilters = createAction('SET_SELECTED_FILTERS');
export const clearPassengerFilters = createAction('CLEAR_FILTERS');
